/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import "corejs-typeahead";
import Hammer from "hammerjs";
import Cookies from "js-cookie";
import Bloodhound from "corejs-typeahead/dist/bloodhound.min";
import { is_breakpoint_up, make_url } from "./helpers/functions";
import App from "./helpers/app";
import PerfectScrollbar from "perfect-scrollbar";
import $ from "jquery";
import OneTrustService from "./services/OneTrust/OneTrustService";
import OneTrustGroupEnum from "./services/OneTrust/OneTrustGroupEnum";

window.lazyLoaded = [];
document.addEventListener("lazybeforeunveil", function (e) {
  let bg = e.target.getAttribute("data-bg");
  if (bg) {
    e.target.style.backgroundImage = "url(" + bg + ")";
  } else {
    let swiperName = e.target.getAttribute("data-lazy-swiper");
    if (swiperName) {
      window.lazyLoaded.push(swiperName);
      $(document).trigger("swiper.lazy." + swiperName);
    }
  }
});

$(function () {
  $('[data-check-all] input[type="checkbox"]').change(function () {
    const container = $($(this).closest("[data-check-all]").data("check-all"));
    const collapse = $(this)
      .closest("[data-check-all]")
      .data("check-all-collapse");
    if (container.length) {
      if (container.hasClass("collapse") && collapse) {
        container.collapse("show");
      }
      let checkboxes = container.find('input[type="checkbox"]');
      if (collapse) {
        checkboxes = checkboxes.filter(":visible");
      }
      if (checkboxes.length) {
        checkboxes.prop("checked", $(this).prop("checked"));
      }
    }
  });

  $(document).on("param:change", function (e, formName, name, value, state) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "formParamChange",
      formName: formName,
      paramName: name,
      paramValue: value,
      paramState: state ? "on" : "off",
    });
  });

  $(document).on("address:change", function (e, url) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "internalUrlChange",
      internalUrl: url,
    });
  });

  $(document).on("lead:change", function (e, changed) {
    let eventSended = false;
    window.dataLayer = window.dataLayer || [];
    if (window.dataLayer.length) {
      $.each(window.dataLayer, function (k, v) {
        if (v.event === "productPageConfigChange") {
          eventSended = true;
        }
      });
    }

    window.dataLayer.push({
      event: "productPageConfigChange",
      configChanged: changed,
      isFirstChange: !eventSended,
    });
  });

  function initHeaderEvents() {
    let $headerBegin = $("header .header-begin");
    if ($headerBegin.children().length) {
      let $spacer = $('<div class="header-spacer"></div>');
      $spacer.append($headerBegin.children().clone());
      $("body").prepend($spacer);
    }
  }

  initHeaderEvents();

  function initNavEvents() {
    new PerfectScrollbar($("nav .nav-screen .nav-body").get(0));
  }

  initNavEvents();

  function initSearchEvents() {
    $("header .search").on("click", function (e) {
      if (
        $("html").hasClass("search-opened") &&
        !is_breakpoint_up("lg") &&
        $(e.target).hasClass("search")
      ) {
        $("html").removeClass("search-opened");
      }
    });

    var searchInput = $("[data-site-search]");
    if (searchInput.length) {
      let selectResult = function () {
        let suggestion = searchInput
          .closest(".twitter-typeahead")
          .find(".tt-dataset .tt-suggestion:first-child");
        if (suggestion.length) {
          suggestion.click();
        }
      };

      searchInput.closest("form").submit(function (e) {
        e.preventDefault();
        selectResult();
      });

      searchInput.focus(function () {
        if ($(this).val()) {
          return;
        }

        $(this).animate(
          {
            opacity: 0,
          },
          300,
          function () {
            $(this).attr("placeholder", "Wpisz markę, model lub nadwozie");

            $(this).animate(
              {
                opacity: 1,
              },
              300,
            );
          },
        );
      });

      searchInput.blur(function () {
        if ($(this).val()) {
          return;
        }

        $(this).animate(
          {
            opacity: 0,
          },
          300,
          function () {
            $(this).attr("placeholder", "Znajdź wymarzone auto");

            $(this).animate(
              {
                opacity: 1,
              },
              300,
            );
          },
        );
      });

      searchInput.keydown(function (e) {
        if (e.which == 13 && $(this).val() != "") {
          selectResult();
        }
      });

      let searchUrl = make_url("/carsell/offers/search?q=%QUERY");

      var searchProducts = new Bloodhound({
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
          url: searchUrl,
          wildcard: "%QUERY",
        },
      });

      searchInput.typeahead(
        {
          highlight: false,
          hint: false,
          minLength: 1,
        },
        {
          display: function (suggestion) {
            return "";
          },
          name: "searchProducts",
          source: searchProducts,
          limit: 12,
          templates: {
            notFound:
              '<div class="search-not-found">Brak wyników. Spróbuj jeszcze raz.</div>',
            suggestion: function (data) {
              return [
                '<div class="search-item">',
                '   <div class="search-header" data-type="' +
                  data.type +
                  '">' +
                  data.type_name +
                  "</div>",
                '   <div class="search-item"><div class="item"><div class="name">' +
                  data.name +
                  "</div>" +
                  (data.body_types
                    ? '<span class="body-types">' + data.body_types + "</span>"
                    : "") +
                  "</div></div>",
                "</div>",
              ].join("\n");
            },
          },
        },
      );

      searchInput.bind("typeahead:open", function () {
        $(".search-group .tt-menu").css(
          "maxHeight",
          $(window).height() - $("header").height(),
        );
      });

      searchInput.bind(
        "typeahead:render",
        function (ev, suggestions, async, dataset) {
          var items = $(ev.target)
            .closest(".twitter-typeahead")
            .find(".tt-suggestion");
          var header = "";
          items.each(function () {
            var el = $(this);
            var headerItem = el.find(".search-header");
            var typeGroups = headerItem.data("type").split(".");
            var type = typeGroups[0];
            if (type === "version") {
              type = "model";
            }
            typeGroups[0] = type;
            type = typeGroups.join(".");
            if (type != header) {
              header = type;
              headerItem.show();
            }
          });
        },
      );

      searchInput.bind("typeahead:select", function (ev, suggestion) {
        if (typeof suggestion.idaggregate !== null && suggestion.idaggregate) {
          if (OneTrustService.isOn(OneTrustGroupEnum.STRICTLY)) {
            Cookies.set("visit_" + suggestion.idaggregate, suggestion.natcode, {
              expires: 1,
            });
          }
        }

        window.location.href = suggestion.url;
      });
    }
  }

  initSearchEvents();

  function initRulesEvents() {
    $("[data-rule-more]").click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      let content = $(this).data("rule-more");
      if (content.substring(0, 1) === "#") {
        content = $(content).html();
      }
      App.modal.html('<div class="modal-body">' + content + "</div>");
    });
  }

  initRulesEvents();
});

function initButtonGroupSwipe(obj) {
  let swipeTreshold = null;

  function updateGroup($btn) {
    if ($btn.is("font")) {
      $btn = $btn.closest(".btn");
    }
    $btn = $btn.filter(".btn").not(".active-indicator");
    if (!$btn.length) {
      return;
    }

    let $group = $btn.parent();
    let $indicator = $group.find(".active-indicator");
    let $width = $btn.outerWidth();
    let $offset = $btn.position().left;
    let $isInit = !$indicator.length;

    if ($isInit) {
      $indicator = $(
        '<div class="active-indicator btn btn-shadow-light"><input type="checkbox" class="d-none"></div>',
      );
    }

    $indicator.css({
      width: $width,
      left: $offset,
    });

    if ($isInit) {
      $group.prepend($indicator);
    }
  }

  obj
    .find(
      ".btn-group.default-btn-group > label.active, .btn-group.default-btn-group > li.active",
    )
    .each(function () {
      updateGroup($(this));
    });

  obj
    .off("click", ".btn-group.default-btn-group > label:not(.disabled)")
    .on(
      "click",
      ".btn-group.default-btn-group > label:not(.disabled)",
      function () {
        updateGroup($(this));
      },
    );

  obj
    .find('.btn-group.default-btn-group input[type="radio"]')
    .off("change")
    .on("change", function () {
      updateGroup($(this).parent());
    });

  $(window)
    .off("load.bs.button.data-api")
    .on("load.bs.button.data-api", function () {
      obj.find(".btn-group.default-btn-group > label:not(.disabled)");
    });

  $(window)
    .off("resize.buttonGroupSwipe updateButtonGroupSwipe")
    .on("resize.buttonGroupSwipe updateButtonGroupSwipe", function () {
      $("body")
        .find(
          ".btn-group.default-btn-group > label.active, .btn-group.default-btn-group > li.active",
        )
        .each(function () {
          updateGroup($(this));
        });
    });

  let observer = new MutationObserver(function (mutations) {
    $.each(mutations, function (k, v) {
      updateGroup($(v.target));
    });
  });
  let target = document.querySelector(
    ".btn-group.default-btn-group > label.active, .btn-group.default-btn-group > li.active",
  );
  if (target) {
    observer.observe(target, {
      // attributes: true,
      subtree: true,
      characterData: true,
      childList: true,
    });
  }

  $(".nav.nav-underlined").each(function () {
    let mc = new Hammer.Manager($(this)[0]);
    mc.add(
      new Hammer.Swipe({
        direction: Hammer.DIRECTION_HORIZONTAL,
        threshold: 0,
      }),
    );
    mc.on("swipe", function (e) {
      let $el = $(e.target);
      let $active;
      if ($el.is(".nav-link")) {
        $active = $el.closest(".nav").find(".nav-link.active");
      } else {
        $active = $el.find(".nav-link.active");
      }
      let $prev = $active
        .closest(".nav-item")
        .prev(".nav-item")
        .find(".nav-link");
      let $next = $active
        .closest(".nav-item")
        .next(".nav-item")
        .find(".nav-link");

      if (e.direction == Hammer.DIRECTION_RIGHT && $next.length) {
        $next.click();
      } else if (e.direction == Hammer.DIRECTION_LEFT && $prev.length) {
        $prev.click();
      }
    });
  });

  $(".btn-group.default-btn-group").each(function () {
    let mc = new Hammer.Manager($(this)[0]);
    mc.add(
      new Hammer.Swipe({
        direction: Hammer.DIRECTION_HORIZONTAL,
        threshold: 0,
      }),
    );
    mc.on("swipe", function (e) {
      let $el = $(e.target);
      let $active;
      if ($el.is(".btn")) {
        $active = $el.closest(".btn-group").find(".btn.active");
      } else {
        $active = $el.find(".btn.active");
      }
      let $prev = $active.prev(".btn:not(.active-indicator)");
      let $next = $active.next(".btn:not(.active-indicator)");

      if (e.direction == Hammer.DIRECTION_RIGHT && $next.length) {
        $next.get(0).click();
      } else if (e.direction == Hammer.DIRECTION_LEFT && $prev.length) {
        $prev.get(0).click();
      }
    });
  });
}

App.registerApp = function (obj) {
  initButtonGroupSwipe(obj);
};
